import axios from 'axios'
import { baseUrl } from './'

export function login ({email, password}) {
  return axios.create().post(`${baseUrl}/login`, { email, password })
}

export function resetPassword ({email}) {
  return new Promise((resolve, reject) => {
    reject(new Error('not implemented'))
  })
}

export function changePassword ({password, passwordConfirmation}) {
  return new Promise((resolve, reject) => {
    reject(new Error('not implemented'))
  })
}



// WEBPACK FOOTER //
// ./src/api/session.js